import { motion, MotionValue, useTransform, useViewportScroll } from 'framer-motion';
import React from 'react';
import { tabsType } from '../../libs/typeInterface';
import AboutProduct from '../AboutProduct';
import WhatIsIn from '../WhatIsIn';

interface IAboutFullKit {
  productSelected: string;
  tabs: tabsType[];
  // tslint:disable-next-line: no-any
  inside: any;
}

const AboutFullKit = (props: IAboutFullKit) => {
  const { productSelected, tabs, inside } = props;

  let scaleAnim1: MotionValue<number>;
  let scaleAnim2: MotionValue<number>;
  let scaleAnim3: MotionValue<number>;

  let yPosAnim1: MotionValue<number>;
  let yPosAnim2: MotionValue<number>;
  let yPosAnim3: MotionValue<number>;

  let xPosAnim1: MotionValue<number>;
  let xPosAnim2: MotionValue<number>;
  let xPosAnim3: MotionValue<number>;

  const { scrollYProgress } = useViewportScroll();

  // serum
  scaleAnim1 = useTransform(scrollYProgress, [0, 0.1, 1], [0, 0.01, 1.5]);
  yPosAnim1 = useTransform(scrollYProgress, [2500, 1.3, 0], [0, 2900, -480]);
  xPosAnim1 = useTransform(scrollYProgress, [450, 1.5, 0], [1, 0, 150]);

  // cream
  scaleAnim2 = useTransform(scrollYProgress, [0, 0.2, 1.2], [0, 0, 1.5]);
  yPosAnim2 = useTransform(scrollYProgress, [2500, 1.3, 0], [0, 2900, -550]);
  xPosAnim2 = useTransform(scrollYProgress, [550, 1.5, 0], [1, 0, 100]);

  // facewash
  scaleAnim3 = useTransform(scrollYProgress, [0, 0.5, 1], [0, 0.01, 1.4]);
  yPosAnim3 = useTransform(scrollYProgress, [2000, 1.3, 0.1], [1000, 1800, -450]);
  xPosAnim3 = useTransform(scrollYProgress, [450, 1.5, 0], [1, 0, 100]);

  return (
    <>
      <div className="lg:mt-20 w-full flex justify-center flex-wrap relative overflow-hidden">
        {productSelected === 'face-brightening-kit' && (
          <>
            <div className="w-full flex justify-center flex-wrap relative overflow-hidden">
              <AboutProduct productSelected="serum" tabs={tabs} />
              <motion.div
                className="xs:hidden lg:block lg:absolute"
                style={{
                  scale: scaleAnim1,
                  x: xPosAnim1,
                  y: yPosAnim1
                }}
              >
                <img
                  src="/images/serum-drop.png"
                  className="relative w-full h-full object-contain"
                />
              </motion.div>
              <WhatIsIn product="serum" inside={inside[0]} />
            </div>
            <div className="w-full flex justify-center flex-wrap relative overflow-hidden">
              <p className="w-full xs:hidden lg:flex items-center justify-start xs:px-4 lg:px-8 lg:container lg:mx-auto relative">
                <img
                  src="/images/cream.png"
                  className="transform ml-20 mb-10"
                  style={{ width: '50%', transform: 'rotateY(-180deg)' }}
                />
                <motion.div
                  className="xs:hidden lg:block lg:absolute"
                  style={{
                    scale: scaleAnim2,
                    x: xPosAnim2,
                    y: yPosAnim2
                  }}
                >
                  <img
                    src="/images/cream-drop.png"
                    className="relative w-full h-full object-contain"
                  />
                </motion.div>
              </p>

              <WhatIsIn product="cream" inside={inside[1]} />
            </div>
            <p className="w-full xs:hidden lg:flex items-center justify-start xs:px-4 lg:px-8 lg:container lg:mx-auto relative">
              <img
                src="/images/facewash-open-cap.png"
                className="transform ml-20"
                style={{ width: '60%', transform: 'rotateY(-180deg)' }}
              />
              <motion.div
                className="xs:hidden lg:block lg:absolute"
                style={{
                  scale: scaleAnim3,
                  x: xPosAnim3,
                  y: yPosAnim3
                }}
              >
                <img
                  src="/images/facewash-drop.png"
                  className="relative w-full h-full object-contain"
                />
              </motion.div>
            </p>

            <WhatIsIn product="facewash" inside={inside[2]} />
          </>
        )}
      </div>
    </>
  );
};

export default AboutFullKit;
